import { JSONContent } from '@tiptap/core';
import { CustomSectionNodeType } from 'api/custom-section/types';
import { PagesAPI } from 'api/pages';
import { useCallback } from 'react';
import type { GroupSectionStreamingMeta } from './types';
import type { CustomGroupSectionAttributes } from 'api/custom-section/types';

export const useDefaultCustomGroupSectionNodeResolver = ({
  documentId,
}: {
  documentId: number;
}): ((
  attributes: CustomGroupSectionAttributes,
  content?: JSONContent[],
) => Promise<{
  streamingMeta: GroupSectionStreamingMeta;
  finalContent?: { content?: JSONContent[] };
}>) => {
  return useCallback(
    async (
      attributes: CustomGroupSectionAttributes,
      content: JSONContent[] = [],
    ) => {
      const response = await PagesAPI.resolveCustomSection(documentId, {
        type: CustomSectionNodeType.RlGroupSection,
        attrs: attributes,
        content,
      } as unknown as Parameters<typeof PagesAPI.resolveCustomSection>[1]);
      const streamingMeta = (
        response as { streamingMeta?: GroupSectionStreamingMeta }
      )?.streamingMeta;
      const finalContent = (
        response as { finalContent?: { content?: JSONContent[] } }
      )?.finalContent;

      if (!streamingMeta?.token || !streamingMeta?.channelName) {
        throw new Error('Resolver did not return streamingMeta');
      }

      return { streamingMeta, finalContent };
    },
    [documentId],
  );
};
